import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=0a1e9ca5&"
import script from "./Inbox.vue?vue&type=script&lang=ts&"
export * from "./Inbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports